import RootStore from "./RootStore";
import { IResult, IImageSignature, IImageUpload } from "../global";
import commonApi from "../actions/common";
import moment from "moment";
import { observable, action, computed } from "mobx";

export default class CommonStore {
  rootStore: RootStore;

  imageSign: IImageSignature;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.imageSign = {
      accessid: "",
      host: "",
      policy: "",
      signature: "",
      expire: 0,
      dir: "",
    } as IImageSignature;
  }

  preorder = (data: any) => {
    return commonApi.preorder(data);
  };

  getImageSign = (force?:number) => {
    return new Promise<IImageSignature>((resolve) => {
      if (this.imageSign) {
        const { expire } = this.imageSign;

        if (moment(expire * 1000).isAfter(moment())) {
          resolve(this.imageSign);
          return;
        }
      }

      // 重新请求
      commonApi.imageSign(force, !!Number(window.configDetail.use_global)).then(
        action((res: IResult) => {
          const data = res.data as IImageSignature;
          this.imageSign = data;
          resolve(this.imageSign);
        })
      );
    });
  };

  uploadImage = (data: IImageUpload, type: string, force?:boolean) => {
    return new Promise<IResult>((resolve, reject) => {
      this.getImageSign(!!force ? 1 : 0).then((sign: IImageSignature) => {
        // 可以上传了
        data.policy = this.imageSign.policy;
        data.OSSAccessKeyId = this.imageSign.accessid;
        data.success_action_status = 200;
        data.signature = this.imageSign.signature;

        const { file, key } = data;
        // 检查key是否在指定目录内
        if (key.indexOf(this.imageSign.dir) == 0) {
          commonApi
            .uploadImage(this.imageSign.host, data, type)
            .then((res: IResult) => {
              resolve(res);
            });
        } else {
          reject();
        }
      });
    });
  };
}
